import React from "react";
import { Route, Routes } from "react-router-dom";
import {
  EMISSION_FACTORS_FILES,
  EMISSION_FACTORS_FILES_FOLDERS,
} from "./consts";
import { EmissionFactorsPage } from "./page";
import { FilesPage } from "./filespage";
import FoldersPage from "./folderpages";

export const ResourcesRouter = () => (
  <Routes>
    <Route path="/" element={<EmissionFactorsPage />} />
    <Route
      path={EMISSION_FACTORS_FILES.PATH}
      element={<FilesPage />}
    />
    <Route
      path={EMISSION_FACTORS_FILES_FOLDERS.PATH}
      element={<FoldersPage />}
    />
  </Routes>
);
